import { map } from 'd3-collection';

const lookup = map();

const buildURL = path => `${process.env.PUBLIC_PATH}${path}`;

// gov race
lookup.set("Beto O'Rourke", buildURL('assets/images/beto.png'));

lookup.set('Greg Abbott', buildURL('assets/images/abbott.png'));

// ag race (just in case)

lookup.set('Ken Paxton', buildURL('assets/images/paxton.png'));

lookup.set('Rochelle Garza', buildURL('assets/images/garza.png'));

export { lookup };
